import { Injectable } from '@angular/core';
import {
  CustomMessageListener,
  LuigiCoreService,
  LuigiNodesService,
} from '@openmfp/portal-ui-lib';

@Injectable({
  providedIn: 'root',
})
export class FrameEntityChangedListener implements CustomMessageListener {
  constructor(
    private luigiNodesService: LuigiNodesService,
    private luigiCoreService: LuigiCoreService,
  ) {}

  messageId(): string {
    return 'general.frame-entity-changed';
  }

  onCustomMessageReceived(): void {
    this.clearCaches();
  }

  private clearCaches() {
    this.luigiNodesService.clearNodeCache();
    this.luigiCoreService.clearNavigationCache();
    this.luigiCoreService.configChanged();
  }
}
